import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseInspectionsStepsWorker } from '../workers/inspections.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';
import { logger } from '@sentry/angular';

class WarehouseInspectionsSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseInspectionsStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseInspectionsStepsWorker | Remote<WarehouseInspectionsStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/inspections.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseInspectionsStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseInspectionsStepsWorker()];
  }
}

export class WarehousePushInspectionsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_INS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.info('Executing push inspections sync task', { category: 'sync', division: ctx.division });
    await executeWorker(ctx, this.environment, listener, new WarehouseInspectionsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseDownloadInspectionsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_INS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.info('Executing download inspections sync task', { category: 'sync', division: ctx.division });
    await executeWorker(ctx, this.environment, listener, new WarehouseInspectionsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanInspectionsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_INS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.info('Executing clean inspections sync task', { category: 'sync', division: ctx.division });
    await executeWorker(ctx, this.environment, listener, new WarehouseInspectionsSyncWorkerFactory(), taskBreaker);
  }
}
